import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export type AppMode = 'corp' | 'pay'

export const useAppModeStore = defineStore('appMode', () => {
  const savedMode = sessionStorage.getItem('ecx-auth-mode')
  const initialMode: AppMode = savedMode === 'corp' ? 'corp' : 'pay'
  
  const _mode = ref<AppMode>(initialMode)
  
  const showSwitch = computed(() => {
    const envValue = import.meta.env.VITE_SHOW_CORP_SWITCH
    
    if (envValue !== undefined && envValue !== '') {
      return envValue === 'true'
    }
    
    return import.meta.env.DEV || import.meta.env.MODE === 'staging'
  })
  
   /**
  * Modo vem sempre de _mode (sessionStorage / setMode).
  * showSwitch só controla se o AppSwitcher aparece — não força Pay,
  * senão deep-link Corp (?mode=corp) e Docker com switch oculto quebram.
  */
  const mode = computed(() => _mode.value)
  
  const isCorp = computed(() => mode.value === 'corp')
  const isPay = computed(() => mode.value === 'pay')
  
  const apiUrl = computed(() => {
    if (mode.value === 'corp') {
      return import.meta.env.VITE_CORP_API_URL || 'http://localhost:3002'
    }
    return import.meta.env.VITE_API_URL || 'http://localhost:3000'
  })
  
  const redirectUrl = computed(() => {
    if (mode.value === 'corp') {
      return import.meta.env.VITE_CORP_URL || 'http://localhost:8082'
    }
    return import.meta.env.VITE_PAY_URL || 'http://localhost:8080'
  })
  
  const setMode = (newMode: AppMode) => {
    _mode.value = newMode
    sessionStorage.setItem('ecx-auth-mode', newMode)
  }
  
  return {
    mode,
    isCorp,
    isPay,
    apiUrl,
    redirectUrl,
    showSwitch,
    setMode,
  }
})

